const consumerAssetTypes = [
  {
    label: "Motor Vehicle",
    icon: "DirectionsCar",
    category: 1,
    value: "",
    modalTypeCode: "APAS",
  },
  {
    label: "Electric Motor Vehicle",
    icon: "DirectionsCar",
    category: 1,
    value: "",
    modalTypeCode: "APAS",
  },
  {
    label: "Luxury Vehicle",
    icon: "DirectionsCar",
    category: 1,
    modalTypeCode: "APAS",
    value: "",
  },
  {
    label: "Motorbike",
    icon: "Fastfood",
    category: 3,
    modalTypeCode: "B",
    value: "",
  },
  {
    label: "ATV/Off-Road Bike",
    icon: "Fastfood",
    category: 3,
    value: "",
  },
  {
    label: "Tractor",
    icon: "Fastfood",
    category: 3,
    value: "",
  },
  {
    label: "Ride on mower",
    icon: "Fastfood",
    category: 3,
    value: "",
  },
  {
    label: "Horse float",
    icon: "Build",
    category: 2,
    value: "",
  },
  {
    label: "Trailer",
    icon: "Build",
    category: 2,
    value: "",
  },
  {
    label: "Caravan",
    icon: "Build",
    category: 2,
    modalTypeCode: "C",
    value: "",
  },
  {
    label: "Motor home",
    icon: "Build",
    category: 2,
    modalTypeCode: "C",
    value: "",
  },
  {
    label: "Trailered boat",
    icon: "Build",
    category: 2,
    value: "",
  },
  {
    label: "Jetski/PWC",
    icon: "Build",
    category: 2,
    value: "",
  },
  {
    label: "Golf carts",
    icon: "Build",
    category: 2,
    value: "",
  },
  {
    label: "========== New ==========",
    icon: "Build",
    category: 2,
    value: "",
  },
  {
    "label": "Motorbike (Off Road)",
    "icon": "DirectionsCar",
    "category": 3,
    "modalTypeCode": "B",
    "value": ""
  },
  {
    "label": "ATV",
    "icon": "DirectionsCar",
    "category": 3,
    "modalTypeCode": "C",
    "value": ""
  },
  {
    "label": "SSV",
    "icon": "DirectionsCar",
    "category": 3,
    "modalTypeCode": "",
    "value": ""
  },
  {
    "label": "Outboard Motor",
    "icon": "DirectionsCar",
    "category": 3,
    "modalTypeCode": "",
    "value": ""
  },
  {
    "label": "Control Box",
    "icon": "DirectionsCar",
    "category": 3,
    "modalTypeCode": "",
    "value": ""
  },
  {
    "label": "Jetski/PWC with Trailer",
    "icon": "Build",
    "category": 2,
    "modalTypeCode": "",
    "value": ""
  },
  {
    "label": "Diesel Engine",
    "icon": "DirectionsCar",
    "category": 3,
    "modalTypeCode": "",
    "value": ""
  },
  {
    "label": "Boats",
    "icon": "DirectionsCar",
    "category": 3,
    "modalTypeCode": "",
    "value": ""
  },
  {
    "label": "Aluminium Boats",
    "icon": "DirectionsCar",
    "category": 3,
    "modalTypeCode": "",
    "value": ""
  },
  {
    "label": "Stern Drive",
    "icon": "DirectionsCar",
    "category": 3,
    "modalTypeCode": "",
    "value": ""
  },
  {
    "label": "Electric Bicycle",
    "icon": "DirectionsCar",
    "category": 3,
    "modalTypeCode": "",
    "value": ""
  },
  {
    "label": "MBK Bicycle",
    "icon": "DirectionsCar",
    "category": 3,
    "modalTypeCode": "",
    "value": ""
  },
  {
    "label": "Inboard Motors",
    "icon": "DirectionsCar",
    "category": 3,
    "modalTypeCode": "",
    "value": ""
  },
  {
    "label": "Marine Package",
    "icon": "DirectionsCar",
    "category": 3,
    "modalTypeCode": "",
    "value": ""
  },
  {
    "label": "Trailers (car)",
    "icon": "DirectionsCar",
    "category": 3,
    "modalTypeCode": "",
    "value": ""
  }
];
export default consumerAssetTypes;
